/**
 * "Claims: Standard | Weighted" — beside Include management, at the top of each page.
 *
 * Weighted counts each billed claim by the claim rules (docs/RULES.md): coinsurance
 * payers at their weight, or 0 where they do not count for the credited biller; hard
 * payers at their weight (1 unless set). Every figure that divides by claims follows it — cost per
 * claim, claims per month, scores and ranks. Closed % stays on standard claims, since
 * resolved claims are not weighted.
 *
 * Starts on Standard on every visit (data/weights.ts). Greyed, with the reason, when the
 * weights could not be loaded. The note says where the figures come from: the model
 * (official), the model with a newer rule not yet applied, or the app's own preview
 * (data/weightsNote.ts).
 */
import { useAppData } from '@/data/AppData'
import { define } from '@/measures/definitions'
import { Info } from './Info'
import { weightsNote } from '@/data/weightsNote'

export function ClaimBasisToggle() {
  const { claimBasis, setClaimBasis, weights } = useAppData()
  const on = claimBasis === 'weighted'
  const ready = weights.status === 'ok'
  const note = weightsNote(weights, on)
  return (
    <div className="mgmt-toggle" style={{ marginTop: -8 }}>
      <button
        type="button"
        role="switch"
        aria-checked={on}
        className="switch"
        disabled={!ready && !on}
        title={ready ? undefined : note}
        onClick={() => setClaimBasis(on ? 'standard' : 'weighted')}
        style={!ready && !on ? { opacity: 0.55, cursor: 'not-allowed' } : undefined}
      >
        <span className="switch-track" aria-hidden="true">
          <span className="switch-thumb" />
        </span>
        <span className="switch-label">Weighted claims</span>
      </button>
      <span className="mgmt-toggle-note">{note}</span>
      <Info def={define('claimBasis')} />
    </div>
  )
}
